import React, { useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";

const Tabs = ({ tabs, className = "" }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleWheel = (e) => {
      if (e.deltaY === 0) return;
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    };

    el.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      el.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <div className={`border-b ${className}`}>
      <div ref={scrollRef} className="overflow-x-auto custom-scrollbar">
        <div className="flex gap-4 whitespace-nowrap max-w-1">
          {tabs.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `px-4 py-2 border-b-2 flex-shrink-0 ${
                  isActive
                    ? "border-primary text-primary font-semibold"
                    : "border-transparent text-gray-600"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
